

export type PolicyName = string;

export interface IPolicy {

	/**
	 * The policy name.
	 */
	readonly name: PolicyName;
}
